import {path} from 'd3';

export const USER_ACCESS_TAB_LIST = {
  user: [
    {label: 'Active', value: 'active'},
    {label: 'Inactive', value: 'inactive'},
  ],
  group: [],
  pic: [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Completed',
      value: 'completed',
    },
    {
      label: 'Incomplete',
      value: 'incomplete',
    },
  ],
};

export const GROUP_ACCESS_LIST = [
  {
    value: 'digital_mapping_viewer',
    label: 'Digital Mapping Viewer',
  },
  {
    value: 'lintramax_viewer',
    label: 'Lintramax Viewer',
  },
  {
    value: 'digital_mapping_admin',
    label: 'Digital Mapping Admin',
  },
  {
    value: 'user_management_admin',
    label: 'User Management Admin',
  },
  {
    value: 'application_management_admin',
    label: 'Application Management Admin',
  },
  {
    value: 'atd_admin',
    label: 'Analisa Tanah dan Daun (ATD) Admin',
  },
  {
    value: 'pengesyoran_baja_admin',
    label: 'Pengesyoran Baja Admin',
  },
  {
    value: 'kewangan_admin',
    label: 'Kewangan Admin',
  },
  {
    value: 'peserta_lot_admin',
    label: 'Peserta dan Lot Admin',
  },
  {
    value: 'pppls_data_admin',
    label: 'PPPLS Data Admin',
  },
  {
    value: 'documentation_admin',
    label: 'Documentation Admin',
  },
];

export const DOCUMENTATION_TAB_LIST = [
  {
    label: 'SOP',
    path: 'root/SOP/',
    value: 2,
  },
  {
    label: 'Pekeliling',
    path: 'root/Pekeliling/',
    value: 3,
  },
  {
    label: 'Laporan KNL',
    path: 'root/Laporan_KNL/',
    value: 4,
  },
  {
    label: 'QA',
    path: 'root/QA/',
    value: 5,
  },
  {
    label: 'ATD',
    path: 'root/ATD/',
    value: 6,
  },
];

export const UPLOAD_DATA_CENTER_TAB_LIST = {
  programKerja: [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Pembangunan',
      value: 'Pembangunan',
    },
    {
      label: 'Prahasil',
      value: 'Pra Hasil',
    },
    {
      label: 'Berhasil',
      value: 'Berhasil',
    },
    {
      label: 'Sawit',
      value: 'Sawit',
    },
    {
      label: 'Getah',
      value: 'Getah',
    },
  ],
  pengesyoranBaja: [],
  atd: [],
  pppls: [],
  applicationAuthorization: [],
  participantAndLot: [],
  finance: [],
};
